<template>
  <v-layout v-if="hasSelectedWorkpackage" column>
    <div class="sticky-header-group">
      <div class="pa-2">
        <div class="page-rule-heading pr-10 d-inline-flex">
          {{ $t('settings.setLinePricing') }}
        </div>
        <scenario-filter class="d-inline-flex" />
      </div>
      <architecture-group-filter />
    </div>

    <v-flex mt-3>
      <line-pricing-editor
        v-if="isContextReady"
        :scenario-key="scenario"
        :architecture-group-id="architectureGroup"
        :editable="canEditRules"
        :disabled="!isContextReady"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LinePricingEditor from './architecture/components/line-pricing-editor.vue';

export default {
  name: 'LinePricingEditorPage',
  components: {
    LinePricingEditor,
  },
  computed: {
    ...mapGetters('workpackages', ['hasSelectedWorkpackage']),
    ...mapState('filters', ['scenario', 'architectureGroup', 'pricingGroup']),
    ...mapGetters('context', ['isPricingSpecialist']),

    isContextReady() {
      return !!this.pricingGroup && !!this.scenario && !!this.architectureGroup;
    },
    canEditRules() {
      return this.isPricingSpecialist;
    },
  },
};
</script>

<style scoped lang="scss">
.sticky-header-group {
  z-index: 10;
  padding-bottom: 0rem;
  border-radius: 4px;
}
</style>
